export default __webpack_public_path__ + "static/media/apvs-arte-6.dd96d7a6.webp";